<template>
  <div>
    <template v-for="(componente, idx) in componentes">
      <component v-if="componente === current" :is="componente" :key="idx"></component>
    </template>
  </div>
</template>

<script>
import WorkBlocks from "./WorkBlocks";
import AgWorkInterventions from "./AgWorkInterventions";
import UsedMaterials from "./UsedMaterials";
import WasteParts from "./WasteParts";

export default {
  components: {
    WorkBlocks,
    AgWorkInterventions,
    UsedMaterials,
    WasteParts,
  },
  data: () => ({
    editar: false,
    variables: {},
    componentes: [
      'work-blocks',
      'ag-work-interventions',
      'used-materials',
      'waste-parts',
    ]
  }),
  computed: {
    current() {
      return this.$route.params.report
    }
  }
}
</script>
